<template>
  <ul class="cooperative-insight-list" v-if="product.isHighlighted">
    <li v-if="product.isHighlighted" data-test="insight-highlight">
      <span class="highlighted adn-icon adn-icon--category-recommended" aria-hidden="true" />
      <strong>
        {{ i18n._('Recommandé par') }}
        <span data-test="insight-highlight-coop">{{ cooperativeName }}</span>
      </strong>
    </li>
  </ul>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { i18n } from '@b2ag/locale'

export default defineComponent({
  props: {
    product: {
      type: Object,
      required: true,
    },
    cooperativeName: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      i18n,
    }
  },
})
</script>
<style lang="scss">
.cooperative-insight-list {
  display: flex;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  gap: var(--spacing-1);
  margin-bottom: var(--spacing-3);

  @media screen and (min-width: $breakpoint-md) {
    gap: var(--spacing-3);
    flex-direction: row;
  }

  @media screen and (max-width: $breakpoint-sm) {
    flex-direction: column;
  }

  > li {
    display: flex;

    > span {
      margin-right: var(--spacing-1);

      &.highlighted {
        font-size: var(--font-size-l);
        color: var(--color-success);
      }

      &.exclusivity {
        font-size: var(--font-size-l);
        color: var(--color-highlight);
      }
    }
  }
}
</style>
